import {
  Component,
  OnInit,
  Input,
  ElementRef,
  ViewChild,
  Injectable,
  HostListener,
} from '@angular/core';
import { IAttributesSurvey } from '@npm-bbta/bbog-dig-dt-webcomponents-lib/dist/types/components/sherpa-ml/bdb-ml-bm-survey/IAttributesSurvey';
import { timer } from 'rxjs';
import { IUserStorage } from '../../models/userStorage';
import { StorageService } from '../../services/storage/storage.service';
import { ISurveyData } from '../../models/surveyType';
import { DashboardRedirectionService } from '../../services/redirect/redirectService';
import { Endpoints } from '../../models/endpoints';
import { RequestService } from '../../services/request/request.service';

@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
})
export class SurveyComponent implements OnInit {
  @ViewChild('superSurvey', { static: false }) surveyComponent: ElementRef;
  @Input() showSurvey: boolean;
  @Injectable({
    providedIn: 'root',
  })
  public userStorage: IUserStorage;
  constructor(
    private readonly storageService: StorageService,
    private readonly redirectionService: DashboardRedirectionService,
    private readonly requestService: RequestService
  ) {}

  public listSurvey: IAttributesSurvey[] = [];
  public questions: IAttributesSurvey[] = [
    {
      title:
        '¿Consideras que el esfuerzo requerido para la creación de links cumplió con tus expectativas?',
      isRequired: true,
      questions: [
        {
          value: 'rate',
          rate: 5,
          isChecked: true,
          hiddenClose: true,
        },
      ],
    },
    {
      title: 'Last',
      isRequired: true,
      isLast: true,
    },
  ];
  public additionalComments = [
    {
      title: 'Cuéntanos un poco más de tu respuesta',
      isRequired: true,
      questions: [
        {
          value: 'text',
          isTextArea: true,
          isChecked: true,
          hiddenClose: true,
        },
      ],
    },
  ];

  closed = sessionStorage.getItem('closeSurvey') || 'open';
  private surveyCompleted = false;
  private countSubmmit = 0;

  ngOnInit(): void {
    this.listSurvey = this.questions;
  }

  ngAfterViewInit(): void {
    this.countSubmmit = 0;
    this.openSurvey();
  }

  public markSurveyAsCompleted(): void {
    this.surveyCompleted = true;
  }

  openSurvey(): void {
    this.surveyComponent.nativeElement.openSurvey();
  }

  public answerQuestion(e: any): void {
    const currentPage = e.detail.currentPage;
    const rating = e.detail.questions?.[0]?.questions?.[0]?.answerRate;
    if (rating < 3 && currentPage === 1 && this.listSurvey.length < 3) {
      this.addQuestion(currentPage);
    } else if (rating >= 3 && currentPage === 1 && this.listSurvey.length === 3) {
      this.resetQuestions();
    }

    if (currentPage === 1 && rating < 3) {
      this.resetComment();
    }

    if (this.listSurvey[currentPage]?.title === 'Last') {
      this.surveyCompleted = true;
      timer(2000).subscribe(() => {
        this.surveyComponent.nativeElement.closeSurvey();
      });
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): void {
    if (!this.surveyCompleted) {
      $event.returnValue = 'You have unsaved changes! Are you sure you want to leave?';
    }
  }

  async sendSurvey(event: any): Promise<void> {
    const user = this.storageService.getUser() as IUserStorage;
    const { channel, identificationNumber: advisorIdentificationNumber } = user;
    const response: ISurveyData = {
      advisorIdentificationNumber,
      channel,
      rating: event.detail.questions[0]?.questions[0]?.answerRate,
      product: this.redirectionService.getData().product,
    };
    const additionalComment = event.detail.questions?.[1]?.questions?.[0]?.answerText;
    if (additionalComment && additionalComment.length > 1) {
      response.comments = additionalComment;
    }

    this.redirectionService.setRedirected(false);

    if (this.countSubmmit === 0) {
      this.countSubmmit = 1;
      await this.requestService.post(Endpoints.NEWCESRECORD, {
        headers: { 'X-RqUID': user.rqUuid },
        body: JSON.stringify(response),
      });
    }
    this.closed = 'closed';
    window.sessionStorage.setItem('closeSurvey', String(this.closed));
  }

  public addQuestion(currentPage: number) {
    this.listSurvey.splice(currentPage, 0, this.additionalComments[0]);
  }
  public resetQuestions() {
    this.listSurvey.splice(1, 1);
  }
  private resetComment(): void {
    if (this.listSurvey[1]?.questions?.[0]) {
      this.listSurvey[1].questions[0].answerText = '';
    }
  }
}
